<template>
  <v-container fluid style="height: 100vh; max-width: 600px">
    <v-layout column fill-height>
      <v-row class="flex-grow-0">
        <v-toolbar dense elevation="0">
          <v-icon class="pr-1" dense>build</v-icon>
          <v-btn rounded text style="font-size: 110%; padding: 0 5px" @click="selectVehicle">{{ vehicle.numericPlate
            }}
          </v-btn>
          <v-spacer></v-spacer>

          <!-- <v-divider vertical class="my-2" inset /> -->

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionVehicle" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-crosshairs-gps</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.vehicle") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionHistory" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-history</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.history") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionLogbook" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-text-box-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.logbook") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionRefueling" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>local_gas_station</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.refueling") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionEvents" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>event_available</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.events") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500" v-if="canRead('contract')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionContracts" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>widgets</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.contracts") }}</span>
          </v-tooltip>

          <v-divider vertical class="my-2" inset />

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="closeService" v-bind="attrs" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.close") }}</span>
          </v-tooltip>

        </v-toolbar>
      </v-row>
      <v-row class="overflow-hidden" style="max-height: 100%">
        <v-data-table style="max-height: 100vh; width: 600px"
                      :items="plans"
                      item-key="name"
                      class="elevation-0 row-height-event map-table"
                      hide-default-header
                      hide-default-footer
                      fixed-header
                      :items-per-page="-1"
                      height="40vh"
        >
          <template v-slot:header="">
            <thead>
            <tr>
              <th>
                {{ $t("map.panel.service.column.plan.name") }}
              </th>
              <th>
                {{ $t("map.panel.service.column.plan.repetition") }}
              </th>
              <th>
                <div class="d-flex justify-space-between align-center">
                  <div>{{ $t("map.panel.service.column.plan.next") }}</div>
                  <v-tooltip style="z-index: 4000" bottom open-delay="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        elevation="0"
                        x-small
                        fab
                        v-bind="attrs"
                        v-on="on"
                        @click="addPlan">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("map.panel.service.tooltip.add_plan") }}</span>
                  </v-tooltip>
                </div>
              </th>
            </tr>
            </thead>
          </template>
          <template v-slot:item="props">
            <tr v-on:click="rowPlanClick(props.item)"
                v-on:contextmenu="rowMenuClick($event, props.item, true)"
                v-bind:class="{'yellow lighten-4': $store.state.service.plan !== null && props.item.servicePlanId === $store.state.service.plan.servicePlanId}">
              <td style="white-space: nowrap">
                {{ formatPlanName(props.item) }}
              </td>
              <td style="white-space: nowrap">
                <span v-html="formatPlanRepetition(props.item)"></span>
              </td>
              <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 310px">
                <span v-html="formatPlanNext(props.item)"></span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-menu
          v-model="contextPlanMenu"
          :position-x="contextMenuX"
          :position-y="contextMenuY"
          absolute
          offset-y
        >
          <v-list>
            <template v-for="(item, index) in getPlanContextMenuItems(contextObject)">
              <v-divider v-if="item.divider" :key="index + '-div'" class="mx-3" />
              <v-list-item :key="index"
                           link
                           @click="rowPlanMenuItemClick(item)"
              >
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </v-row>
      <v-row class="overflow-hidden" style="max-height: 100%">
        <v-data-table style="max-height: 100vh; width: 600px"
                      :items="services"
                      item-key="name"
                      class="elevation-0 row-height-event map-table"
                      hide-default-header
                      hide-default-footer
                      fixed-header
                      :items-per-page="-1"
                      height="48vh"
        >
          <template v-slot:header="">
            <thead>
            <tr>
              <th>
                {{ $t("map.panel.service.column.service.name") }}
              </th>
              <th>
                {{ $t("map.panel.service.column.service.date") }}
              </th>
              <th>
                <div class="d-flex justify-space-between align-center">
                  <div>{{ $t("map.panel.service.column.service.state") }}</div>
                  <v-tooltip style="z-index: 4000" bottom open-delay="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        ref="btnServiceAdd"
                        color="primary"
                        elevation="0"
                        x-small
                        fab
                        v-bind="attrs"
                        v-on="on"
                        @click="addService">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("map.panel.service.tooltip.add_service") }}</span>
                  </v-tooltip>
                </div>
              </th>
            </tr>
            </thead>
          </template>
          <template v-slot:item="props">
            <tr v-on:click="rowServiceClick(props.item)"
                v-on:contextmenu="rowMenuClick($event, props.item, false)">
              <td style="white-space: nowrap">
                {{ formatServiceName(props.item) }}
              </td>
              <td style="white-space: nowrap">
                {{ formatDate(props.item.date) }}
              </td>
              <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 310px">
                {{ formatServiceState(props.item) }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-menu
          v-model="contextServiceMenu"
          :position-x="contextMenuX"
          :position-y="contextMenuY"
          absolute
          offset-y
        >
          <v-list>
            <v-list-item v-for="(item, index) in getServiceContextMenuItems(contextObject)"
                         :key="index"
                         link
                         @click="rowServiceMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-layout>
    <ServicePlanDialog ref="servicePlanDialog" />
    <ServiceDialog ref="serviceDialog" />
    <ConfirmDialog ref="confirm" />
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { DateTime } from "luxon";
import utils from "@/utils";
import ServicePlanDialog from "@/components/dialogs/ServicePlanDialog.vue";
import ServiceDialog from "@/components/dialogs/ServiceDialog.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";

export default {
  name: "SideService",
  components: { ConfirmDialog, ServicePlanDialog, ServiceDialog },

  props: {
    vehicleSidebarClick: {}
  },

  data() {
    return {
      contextPlanMenu: false,
      contextServiceMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextObject: null
    };
  },

  methods: {
    rowMenuClick(event, item, isPlan) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextObject = item;
      if (isPlan)
        this.contextPlanMenu = true;
      else
        this.contextServiceMenu = true;

      event.preventDefault();
    },

    getPlanContextMenuItems(event) {
      let menu = [];

      if (event !== null) {
        menu.push({ name: "select", title: this.$t("map.panel.service.plan_menu.select") });
        menu.push({ name: "update", title: this.$t("map.panel.service.plan_menu.update") });
        menu.push({ name: "delete", title: this.$t("map.panel.service.plan_menu.delete"), divider: true });
        menu.push({ name: "add", title: this.$t("map.panel.service.plan_menu.addservice"), divider: true });
      }

      return menu;
    },

    rowPlanMenuItemClick(item) {
      switch (item.name) {
        case "select":
          this.rowPlanClick(this.contextObject);
          break;
        case "update":
          this.$refs.servicePlanDialog.open(this.contextObject);
          break;
        case "delete":
          this.deletePlan(this.contextObject);
          break;
        case "add":
          this.$refs.serviceDialog.open({
            planId: this.contextObject.servicePlanId,
            name: this.contextObject.name,
            typeCode: this.contextObject.typeCode,
          });
          break;
      }
    },

    async deletePlan(plan) {
      const result = await this.$refs.confirm.open(
        this.$t("map.panel.service.delete_plan_msg", { plan: this.formatPlanName(plan) }),
        null,
        {
          width: 540,
          buttons: [
            { name: "cancel", text: this.$t("dialog.confirm.button_cancel"), result: null, color: "primary" },
            { name: "delete", text: this.$t("dialog.confirm.button_delete"), result: false, color: "error" },
            { name: "delete_with", text: this.$t("map.panel.service.delete_with"), result: true, color: "error" }
          ]
        });

      if (result !== null) {
        this.$store.dispatch("service/deletePlan", {
          servicePlanId: plan.servicePlanId,
          withServices: result
        });
      }
    },

    addPlan() {
      this.$refs.servicePlanDialog.open(null);
    },

    getServiceContextMenuItems(event) {
      let menu = [];

      if (event !== null) {
        menu.push({ name: "update", title: this.$t("map.panel.service.service_menu.update") });
        menu.push({ name: "delete", title: this.$t("map.panel.service.service_menu.delete") });
      }

      return menu;
    },

    rowServiceMenuItemClick(item) {
      switch (item.name) {
        case "update":
          this.$refs.serviceDialog.open(this.contextObject);
          break;
        case "delete":
          this.deleteService(this.contextObject);
          break;
      }
    },

    addService(service) {
      this.$refs.serviceDialog.open(service || null);
    },

    async deleteService(service) {
      const result = await this.$refs.confirm.open(
        this.$t("map.panel.service.delete_service_msg", { service: this.formatServiceName(service) }),
        null,
        {
          width: 540,
          buttons: [
            { name: "cancel", text: this.$t("dialog.confirm.button_cancel"), result: null, color: "primary" },
            { name: "delete", text: this.$t("dialog.confirm.button_delete"), result: true, color: "error" }
          ]
        });

      if (result !== null) {
        this.$store.dispatch("service/deleteService", {
          serviceId: service.serviceId
        });
      }
    },

    selectVehicle() {
      this.$store.dispatch("dialogs/showDialog", {
        dialog: "vehicleSelection", options: true
      });
    },

    getEventContextMenuItems(ride) {
      let menu = [];

      if (ride !== null) {
        menu.push({ name: "select", title: this.$t("map.panel.logbook.ride_menu.select") });
        if (ride.rideState !== "unfinished" && this.accessRole("admin"))
          menu.push({ name: "update", title: this.$t("map.panel.logbook.ride_menu.update") });
      }

      return menu;
    },

    rowPlanClick(e) {
      this.$store.dispatch("service/fetch", {
        timestamp: e.timestamp,
        planId: (this.$store.state.service.plan === null || this.$store.state.service.plan.servicePlanId !== e.servicePlanId) ? e.servicePlanId : null
      });

      this.$emit("plan-clicked", e);
    },

    rowServiceClick(e) {
      this.$emit("service-clicked", e);
    },

    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    getCurrenDateInMS() {
      return DateTime.now().startOf("day").plus({ "days": 1 }).toISO();
    },

    formatDate(date) {
      if (date !== null)
        return DateTime.fromISO(date, "yyyy-m-d").toLocaleString();
      else
        return "-";
    },

    closeService() {
      this.$store.dispatch("service/clear");
      this.$router.routeToMap();
    },

    actionHistory() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/history",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    actionLogbook() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/logbook",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionRefueling() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/refueling",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionEvents() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/events",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionContracts() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/contracts",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionVehicle() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/vehicle",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    formatServiceName(service) {
      if (service.typeCode === "own")
        return service.name;
      else if (service.name !== null)
        return this.$t("enum.service_type." + service.typeCode) + " - " + service.name;
      else
        return this.$t("enum.service_type." + service.typeCode);
    },

    formatServiceState(service) {
      if (service.km !== null && this.vehicle.typeCode !== "machine")
        return utils.formatDistance(service.km);
      else if (service.eh !== null)
        return utils.formatEngineHours(service.eh);
      else
        return "-";
    },

    formatPlanName(plan) {
      if (plan.typeCode === "own")
        return plan.name;
      else if (plan.name !== null)
        return this.$t("enum.service_type." + plan.typeCode) + " - " + plan.name;
      else
        return this.$t("enum.service_type." + plan.typeCode);
    },

    formatPlanRepetition(plan) {
      const result = [];

      if (plan.repeatedKm !== null)
        result.push(utils.formatDistance(plan.repeatedKm));
      if (plan.repeatedEh !== null)
        result.push(utils.formatEngineHours(plan.repeatedEh));
      if (plan.repeatedPeriod !== null)
        result.push(utils.formatPeriod(plan.repeatedPeriod));

      return this.$options.filters.joinWithSeparator(result,
        "<span style=\"font-style: italic; color: gray\"> " + this.$t("common.or") + " </span>", "-");
    },

    formatPlanNext(plan) {
      const result = [];

      if (plan.diffKm !== null) {
        if (plan.diffKm <= 0)
          result.push(this.$t("common.service_is") + " " + utils.formatDistance(-plan.diffKm));
        else
          result.push("<span style=\"color: red\">" +
            this.$t("common.service_over") + " " + utils.formatDistance(plan.diffKm) + "</span>");
      }

      if (plan.diffEh !== null) {
        if (plan.diffEh <= 0)
          result.push(this.$t("common.service_is") + " " + utils.formatEngineHours(-plan.diffEh));
        else
          result.push("<span style=\"color: red\">" +
            this.$t("common.service_over") + " " + utils.formatEngineHours(plan.diffEh) + "</span>");
      }

      if (plan.diffDays !== null) {
        if (plan.diffDays <= 0)
          result.push(DateTime.fromISO(plan.date).plus({ days: 1 }).toRelative({ unit: "day" }));
        else
          result.push("<span style=\"color: red\">" +
            DateTime.fromISO(plan.date).plus({ days: 1 }).toRelative({ unit: "day" })
            + "</span>");
      }

      return this.$options.filters.joinWithSeparator(result,
        "<span style=\"font-style: italic; color: gray\"> " + this.$t("common.or") + " </span>", "-");
    },

    refreshService() {
      return this.$store.dispatch("service/fetch", {
        vehicle: this.vehicle.vehicle,
        planId: (this.$store.state.service.plan != null)
          ? this.$store.state.service.plan.servicePlanId
          : null
      });
    },

    updateUrl() {
      this.$router.replace({
        name: "map/service",
        params: {
          id: this.$store.state.service.vehicle.vehicleId
        },
        query: {
          ...this.$route.query,
          plan: (this.$store.state.service.plan != null)
            ? this.$store.state.service.plan.servicePlanId
            : undefined
        }
      }).catch(() => {
      });
    }
  },

  watch: {
    "$store.state.service.plan": function() {
      this.updateUrl();
    },

    "$store.state.service.plans": function() {
      this.updateUrl();
    }
  },

  computed: {
    vehicle() {
      return this.$store.state.service.vehicle;
    },

    plans() {
      return this.$store.state.service.plans;
    },

    services() {
      return this.$store.state.service.services;
    }
  },

  mounted() {
  }
};
</script>

<style lang="sass" scoped>
.v-data-table.row-height-event td
  height: 30px !important
/* border: none !important */

</style>